import { Button, Grid } from '@mui/material';
import { Product } from '@thro-types/leihbar';

import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { translations } from 'locales/i18n';
import { useCurrentURL } from 'utils/hooks/useCurrentURL';

import { ProductInfoDisplay } from '../../ProductInfo/components/ProductInfoDisplay';

interface Props {
  product: Product;
}

export const BundleProductPopOver = ({ product }: Props) => {
  const { t } = useTranslation();
  const currentURL = useCurrentURL();
  return (
    <Grid container padding={2}>
      <Grid item className="product-detail__title">
        {product.name}
      </Grid>
      <ProductInfoDisplay label={t(translations.pages.leihbar.product.description())}>
        {parse(product.description)}
      </ProductInfoDisplay>
      {product.hint && (
        <ProductInfoDisplay label={t(translations.pages.leihbar.product.hint())}>
          {product.hint}
        </ProductInfoDisplay>
      )}

      <Grid container item justifyContent={'flex-end'}>
        <Link to={`/leihbar/product/${product.id}`} state={{ back: currentURL }}>
          <Button variant="contained" style={{ color: 'white' }}>
            {t(translations.pages.leihbar.product.bundle.navigateToProduct())}
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};
